export enum DeliveryTimePeriodType {
    Immediate,
    Summer,
    Fall
}
